// extracted by mini-css-extract-plugin
export var container = "Tags-module--container--f7347";
export var fadeInAnimation = "Tags-module--fadeInAnimation--b3285";
export var tag = "Tags-module--tag--b66ea";